import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { LoginSession } from './login-session';
export { LoginSession };
import { loginSessionSchema } from '@schemas/business-objects/login-session';
import { RegistryTokenFormGroup } from './registry-token-form-group';
import { UserFormGroup } from './user-form-group';

export class LoginSessionFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    sessionIdHash: SchemaFormControl;
    status: SchemaFormControl;
    requestedLabel: SchemaFormControl;
    requestedCanPublish: SchemaFormControl;
    expiresAt: SchemaFormControl;
    userId: SchemaFormControl;
    user: UserFormGroup;
    tokenId: SchemaFormControl;
    token: RegistryTokenFormGroup;
  };

  declare value: Partial<LoginSession>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(loginSessionSchema, LoginSession, data, options);
  }

  get object(): LoginSession {
    return new LoginSession(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'user':
        return new UserFormGroup();
      case 'token':
        return new RegistryTokenFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<LoginSession[]> {
    return LoginSession.find(filter);
  }

  static async findOne(filter?: any): Promise<LoginSession | null> {
    return LoginSession.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<LoginSession> {
    return LoginSession.findById(id, filter);
  }

  static async create(data: Partial<LoginSession>): Promise<LoginSession> {
    return LoginSession.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<LoginSession>,
  ): Promise<LoginSession> {
    return LoginSession.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return LoginSession.deleteById(id);
  }
}

export class LoginSessionFormArray extends PersistedFormArray {
  declare controls: LoginSessionFormGroup[];

  readonly entityName = 'LoginSession' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(loginSessionSchema, LoginSession, options);
  }

  protected override createItemGroup() {
    return new LoginSessionFormGroup();
  }

  get array(): LoginSession[] {
    return this.controls.map((group: LoginSessionFormGroup) => group.object);
  }
}

export class LoginSessionPersistedArray extends PersistedArray<LoginSession> {
  readonly entityName = 'LoginSession' as const;

  constructor(options?: PersistedArrayOptions) {
    super(LoginSession, options);
  }
}
